import type {
  NoteValidityStatus,
  StockNoteCategory,
  UserStockNoteDTO,
  UserStockNotePanelResultDTO,
} from "./UserStockNoteType";

function nowText(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

const mockNotes: UserStockNoteDTO[] = [
  {
    id: "NMOCK001",
    stockCode: "600519",
    stockName: "贵州茅台",
    eventTime: "2026-04-09 15:27:00",
    content: "一季报预期向好，渠道反馈动销稳健。",
    category: "基本面",
  },
  {
    id: "NMOCK002",
    stockCode: "600519",
    stockName: "贵州茅台",
    eventTime: "2026-03-18 10:05:00",
    content: "批价短期承压，关注节后回款节奏。",
    category: "消息面",
  },
  {
    id: "NMOCK003",
    stockCode: "300750",
    stockName: "宁德时代",
    eventTime: "2026-05-02 14:20:00",
    content: "储能订单能见度提升，留意毛利率变化。",
    category: "基本面",
  },
];

function findByCode(stockCode: string): UserStockNoteDTO[] {
  const c = stockCode.trim().toUpperCase();
  return mockNotes.filter((n) => String(n.stockCode ?? "").toUpperCase() === c);
}

export const userStockNoteMocks = {
  listNotes(stockCode?: string): UserStockNotePanelResultDTO {
    if (stockCode?.trim()) {
      return { notes: findByCode(stockCode) };
    }
    return { notes: [...mockNotes] };
  },

  queryPanel(stockCode: string): UserStockNotePanelResultDTO {
    return { notes: findByCode(stockCode) };
  },

  create(
    stockCode: string,
    stockName: string,
    content: string,
    category: StockNoteCategory
  ): UserStockNoteDTO {
    const row: UserStockNoteDTO = {
      id: `NMOCK${Date.now()}`,
      stockCode: stockCode.trim().toUpperCase(),
      stockName,
      eventTime: nowText(),
      content,
      category,
    };
    mockNotes.unshift(row);
    return row;
  },

  update(noteId: string, content: string, category: StockNoteCategory): UserStockNoteDTO | null {
    const row = mockNotes.find((n) => n.id === noteId);
    if (!row) {
      return null;
    }
    row.content = content;
    row.category = category;
    row.eventTime = nowText();
    return row;
  },

  delete(noteId: string): boolean {
    const idx = mockNotes.findIndex((n) => n.id === noteId);
    if (idx < 0) {
      return false;
    }
    mockNotes.splice(idx, 1);
    return true;
  },

  markValidity(noteId: string, validityStatus: NoteValidityStatus): UserStockNoteDTO | null {
    const row = mockNotes.find((n) => n.id === noteId);
    if (!row) {
      return null;
    }
    row.validityStatus = validityStatus;
    return row;
  },
};
